import { Box, Checkbox, ModalBody, Text } from '@bechtel/gds';
import { FC, useState } from 'react';
import { MultiLingualText } from '~/components';
import { InputField } from '~/components/atoms/input-field';
import { ButtonStyled, ModalFooterStyled, ModalHeaderStyled, ModalStyled } from './styled';

interface PointGeneratorModalProps {
  visible: boolean;
  close: () => void;
  onGeneratePoints: (startSequence: number, endSequence: number, leadingZeros: boolean) => void;
}

export const PointSequenceModal: FC<PointGeneratorModalProps> = ({ visible, close, onGeneratePoints }) => {
  const [startSequence, setStartSequence] = useState<number>(1);
  const [endSequence, setEndSequence] = useState<number>(12);
  const [leadingZeros, setLeadingZeros] = useState<boolean>(true);
  return (
    <ModalStyled visible={visible}>
      <ModalHeaderStyled title="Auto-Generate Points">
        <Box alignItems={{ sm: 'center' }}></Box>
      </ModalHeaderStyled>
      {/* @ts-ignore adjust in GDS component to take child as prop  */}
      <ModalBody
        css={`
          flex-direction: column;
        `}
      >
        <Box flexDirection={{ sm: 'column' }} p={{ sm: '500' }} gap={{ sm: '500' }}>
          <InputField
            label="Sequence Start"
            value={String(startSequence)}
            onChange={(event) => {
              setStartSequence(Number(event.target.value || 0));
            }}
            type="number"
          ></InputField>
          <InputField
            label="Sequence End"
            value={String(endSequence)}
            onChange={(event) => {
              setEndSequence(Number(event.target.value || 0));
            }}
            type="number"
          ></InputField>
          <Box gap={{ sm: '400' }} alignItems={{ sm: 'center' }}>
            <Checkbox
              checked={leadingZeros}
              onChange={() => {
                setLeadingZeros(!leadingZeros);
              }}
            ></Checkbox>
            <Text size="300">Leading Zeros</Text>
          </Box>
        </Box>
      </ModalBody>
      <ModalFooterStyled>
        <Box p={{ sm: '500' }}>
          <ButtonStyled onClick={close} secondary={true}>
            <Box px={{ sm: '500' }}>
              <MultiLingualText>Cancel</MultiLingualText>
            </Box>
          </ButtonStyled>
          <ButtonStyled
            onClick={() => {
              onGeneratePoints(startSequence, endSequence, leadingZeros);
            }}
            disabled={!startSequence || !endSequence}
          >
            <Box px={{ sm: '500' }}>
              <MultiLingualText>OK</MultiLingualText>
            </Box>
          </ButtonStyled>
        </Box>
      </ModalFooterStyled>
    </ModalStyled>
  );
};
